// Create Session
export const CREATE_SESSION_REQUEST = 'CREATE_SESSION_REQUEST';
export const CREATE_SESSION_SUCCESS = 'CREATE_SESSION_SUCCESS';
export const CREATE_SESSION_ERROR = 'CREATE_SESSION_ERROR';

// Login
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

// Is Logged In
export const IS_LOGGED_IN_REQUEST = 'IS_LOGGED_IN_REQUEST';
export const IS_LOGGED_IN_SUCCESS = 'IS_LOGGED_IN_SUCCESS';
export const IS_LOGGED_IN_ERROR = 'IS_LOGGED_IN_ERROR';

// User Profile
export const USER_PROFILE_REQUEST = 'USER_PROFILE_REQUEST';
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_ERROR = 'USER_PROFILE_ERROR';

// Logout
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';

// Forgot Password
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';

// Reset Password
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

// Mark User Active
export const MARK_USER_ACTIVE_REQUEST = 'MARK_USER_ACTIVE_REQUEST';
export const MARK_USER_ACTIVE_SUCCESS = 'MARK_USER_ACTIVE_SUCCESS';
export const MARK_USER_ACTIVE_ERROR = 'MARK_USER_ACTIVE_ERROR';

// User Permissions
export const GET_USER_ACCESSIBLE_ITEMS_REQUEST =
    'GET_USER_ACCESSIBLE_ITEMS_REQUEST';
export const GET_USER_ACCESSIBLE_ITEMS_SUCCESS =
    'GET_USER_ACCESSIBLE_ITEMS_SUCCESS';
export const GET_USER_ACCESSIBLE_ITEMS_ERROR =
    'GET_USER_ACCESSIBLE_ITEMS_ERROR';

// Otp Resend
export const OTP_RESEND_REQUEST = 'OTP_RESEND_REQUEST';
export const OTP_RESEND_SUCCESS = 'OTP_RESEND_SUCCESS';
export const OTP_RESEND_ERROR = 'OTP_RESEND_ERROR';

// Otp Validate
export const OTP_VALIDATE_REQUEST = 'OTP_VALIDATE_REQUEST';
export const OTP_VALIDATE_SUCCESS = 'OTP_VALIDATE_SUCCESS';
export const OTP_VALIDATE_ERROR = 'OTP_VALIDATE_ERROR';

// Reset Otp Flag
export const RESET_OTP_FLAG = 'RESET_OTP_FLAG';
